var _mask, _path, _rect, _mask2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 76,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 25a3 3 0 0 0 3 3h50a3 3 0 0 0 3-3V13H8v12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8EF",
    d: "M7 25a4 4 0 0 0 4 4h50a4 4 0 0 0 4-4h-2a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2H7Zm57-12H8h56ZM7 13v12a4 4 0 0 0 4 4v-2a2 2 0 0 1-2-2V13H7Zm54 16a4 4 0 0 0 4-4V13h-2v12a2 2 0 0 1-2 2v2Z",
    mask: "url(#a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.5,
    height: 0.5,
    x: 8.25,
    y: 37.25,
    stroke: "#CC3D00",
    strokeWidth: 0.5,
    rx: 0.25
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 50a3 3 0 0 1 3-3h50a3 3 0 0 1 3 3v13H8V50Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8EF",
    d: "M7 50a4 4 0 0 1 4-4h50a4 4 0 0 1 4 4h-2a2 2 0 0 0-2-2H11a2 2 0 0 0-2 2H7Zm57 13H8h56ZM7 63V50a4 4 0 0 1 4-4v2a2 2 0 0 0-2 2v13H7Zm54-17a4 4 0 0 1 4 4v13h-2V50a2 2 0 0 0-2-2v-2Z",
    mask: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.85250b0a5e6d690bf6499c965e769b14.svg";
export { ForwardRef as ReactComponent };